<template>
  <div class="content-v2">
    <div class="news-list-v2">
      <div class="news-row" v-for="news in newsList" :key="news.id">
        <div class="news-date">
          <span class="md">{{ news.monthDay }}</span>
          <span class="year">{{ news.year }}</span>
        </div>
        <router-link :to="'/news/detail/' + news.id" class="news-title-link">
          {{ news.title }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList } from '@/api/portal'
import { formatMonthDay, formatYear } from '@/utils/format'

export default {
  name: 'NewsListV2',
  data() {
    return {
      newsList: [
        { id: 1, title: '公司启动"共读一本书"活动 深化学习型组织建设', monthDay: '03-18', year: '2026' },
        { id: 2, title: '公司举办《企业自运转机制》领导力专项培训', monthDay: '03-14', year: '2026' },
        { id: 3, title: '我司喜迎22名新学员入职 青春力量注入企业发展新动能', monthDay: '03-13', year: '2026' },
        { id: 4, title: '盛博莱电力举办"三八"妇女节主题活动致敬"她力量"', monthDay: '03-06', year: '2026' },
        { id: 5, title: '山东盛博莱电力工程有限公司迎新晚宴圆满落幕', monthDay: '02-11', year: '2026' },
        { id: 6, title: '公司举办年度安全生产总结大会', monthDay: '02-10', year: '2026' }
      ]
    }
  },
  created() {
    this.loadNews()
  },
  methods: {
    loadNews() {
      getNewsList({ pageNum: 1, pageSize: 100 }).then(({ rows }) => {
        if (!rows || !rows.length) {
          return
        }
        this.newsList = rows.map(item => ({
          id: item.newsId,
          title: item.newsTitle,
          monthDay: formatMonthDay(item.publishTime),
          year: formatYear(item.publishTime)
        }))
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.news-list-v2 {
  .news-row {
    display: flex;
    align-items: center;
    padding: 24px 0;
    border-bottom: 1px solid #e2e8f0;
    transition: all 0.3s;

    &:hover {
      padding-left: 16px;
      background: rgba(59,130,246,0.03);
    }

    .news-date {
      width: 90px;
      flex-shrink: 0;
      text-align: center;
      margin-right: 30px;

      .md {
        display: block;
        font-size: 28px;
        font-weight: 800;
        color: #3b82f6;
        line-height: 1;
      }

      .year {
        font-size: 13px;
        color: #94a3b8;
      }
    }

    .news-title-link {
      font-size: 17px;
      font-weight: 500;
      color: #0f172a;
      transition: color 0.3s;

      &:hover {
        color: #3b82f6;
      }
    }
  }
}
</style>
